'use client'

import Link from 'next/link'

const GlobalError = ({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) => (
  <html>
    <body>
      <div>
        <h1>Internal Server Error</h1>
        <p>{error.message}</p>

        <button onClick={() => reset()}>Try again</button>
        <Link href="/">Go back to Home</Link>
      </div>
    </body>
  </html>
)

export default GlobalError
